<template>
  <div class="">
    <v-row>
      <v-col xs6>
        <h1>{{ $t('viewImportToStorage.title')}}</h1>
        <v-progress-circular
            indeterminate
            color="primary"
            v-if="!fetched"
        ></v-progress-circular>
      </v-col>
      <v-col xs6 class="text-right">
        <v-btn
            min-height="48"
            class="mb-0 white--text ml-3 green-shadow float-right"
            @click="importFilesWindow.visible = true"
            color="success"
            :title="$t('common.add')"
        >
          {{$t('common.add')}}
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
        :headers="importToStorageTableHeader"
        :items="importFiles"
        class="elevation-0 mb-3"
        :footer-props="{
        'items-per-page-text': $t('tables.items_per_page'),
        'items-per-page-options': [
          10, 50, 100,
          //-1
        ],
      }"
    >
      <template v-slot:footer.page-text="props">
        {{
          $t("tables.x_of_y", [
            `${props.pageStart}-${props.pageStop}`,
            props.itemsLength,
          ])
        }}
      </template>
      <template v-slot:item="props">
        <tr>
          <td class="text-xs-left text-no-wrap">
            <a :download="props.item.name" :href="downloadPrefixUrl+'/platform'+props.item.path">
              <v-icon class="mr-2" small>$download</v-icon>
            </a>
            {{ props.item.name }}
          </td>
          <td class="text-xs-left">{{props.item.storage && props.item.storage.name}}</td>
          <td class="text-xs-left">{{props.item.rack && props.item.rack.name}}</td>
          <td class="text-xs-left">{{props.item.shelf && props.item.shelf.name}}</td>
          <td class="text-xs-left">{{ props.item.processed}} / {{ props.item.successfully_processed}}</td>
          <td class="text-xs-left">
            {{ props.item.created_at | moment("DD.MM.YYYY") }}
            <br/>
            {{ props.item.created_at | moment("HH:mm") }}
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_data_available") }}
      </template>
      <template v-slot:no-results>
        {{ $t("common.no_data_available") }}
      </template>
    </v-data-table>
    <v-dialog v-model="importFilesWindow.visible" scrollable max-width="600px" persistent>
      <v-card>
        <v-card-title>{{ $t('viewImportToStorage.import_dialog_title') }}
          <v-spacer></v-spacer>
          <v-btn icon @click="importFilesWindow.visible = false;" class="">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-0 mb-0">
          <v-form ref="importFilesForm" v-model="importFilesWindow.formValid">

            <v-select
                :rules="[(v) => !!v || $t('form.validationErrors.field_is_required')]"
                :label="$t('viewGoods.storage')"
                :items="storages"
                item-text="name"
                return-object
                class="pointer"
                clearable
                v-model="importFile.storage"
                @keyup.enter.stop="importFileSave"
            ></v-select>


            <v-select
                v-if="importFile.storage && importFile.storage.rack"
                :label="$t('viewGoods.storage_rack')"
                :items="importFile.storage.rack"
                item-text="name"
                return-object
                class="pointer"
                clearable
                v-model="importFile.rack"
                @keyup.enter.stop="importFileSave"
            ></v-select>


            <v-select
                v-if="importFile.storage && importFile.rack && importFile.rack.shelf"
                :label="$t('viewGoods.storage_rack_shelve')"
                :items="importFile.rack.shelf"
                item-text="name"
                return-object
                class="pointer"
                clearable
                v-model="importFile.shelf"
                @keyup.enter.stop="importFileSave"
            ></v-select>
            <v-file-input
                accept=".xlsx"
                :label="$t('viewImportToStorage.select_file_for_uploading')"
                @change="uploadImportFileChange"
                :rules="[(v) => (!!v && !!v.name) || $t('form.validationErrors.field_is_required')]"
            ></v-file-input>
          </v-form>
        </v-card-text>
        <v-card-actions class="mx-3 mb-2">
          <a target="_blank" :href="fileExample">{{$t('viewImportToStorage.download_file_example')}}</a>
          <div class="flex-grow-1"></div>
          <v-btn
              :loading="savingInProgress"
              :disabled="savingInProgress"
              class="mr-2 mt-4"
              color="primary"
              outlined
              @click.stop="importFileSave"
              @keyup.enter.stop="importFileSave"
          >
            {{ $t('viewImportToStorage.import') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import CommonMixin from "@/mixins/common";
export default {
  name: "ImportToStorage",
  mixins: [CommonMixin],
  data: () => ({
    importFilesWindow: {
      visible: false,
      formValid: false
    }
  }),
  mounted(){
    this.$store.dispatch('goods/getFiles');
    this.$store.dispatch('goods/get');
    this.$store.dispatch('storages/get');
  },
  computed: {
    downloadPrefixUrl(){
      return process.env.VUE_APP_API_ROOT
    },
    fileExample(){
      if(this.lang==='ru'){
        return this.downloadPrefixUrl+'files/import_to_storage_file_example.xlsx';
      } else {
        return this.downloadPrefixUrl+'files/import_to_storage_file_example_en.xlsx';
      }
    },
    ...mapFields('goods', [
      'importFiles',
      'importFile',
      'savingInProgress',
      'fetched'
    ]),
    ...mapFields('storages', [
      'storages',
      'storage_rack',
      'storage_rack_shelf']),
    importToStorageTableHeader() {
      return [
        {text: this.$t('common.file'), value: 'name', sortable: true},
        {text: this.$t('viewGoods.storage'), value: 'storage', sortable: true},
        {text: this.$t('viewGoods.storage_rack'), value: 'storage_rack', sortable: true},
        {text: this.$t('viewGoods.storage_rack_shelve'), value: 'storage_rack_shelve', sortable: true},
        {text: this.$t('viewImportToStorage.processed'), sortable: false},
        {text: this.$t('common.created_at'), value: 'created_at', sortable: true},
      ];
    },
  },
  methods: {
    uploadImportFileChange(file){
      if(file){
        if(file.name){
          this.importFile.filename = file.name;
          this.importFile.extension = file.name.split('.').pop();
        }
      } else {
        this.importFile.filename = null;
        this.importFile.extension = null;
      }
      this.importFile.file = file;
    },
    importFileSave(){
      this.$refs.importFilesForm.validate();
      if (this.importFilesWindow.formValid) {
        this.$store.dispatch('goods/importFileSave')
            .then((res) => {
              if (res && res.id > 0) {
                this.$store.dispatch('goods/getFiles');
                this.importFilesWindow.visible = false;
                this.$refs.importFilesForm.reset();
                this.importFile.file = null;
                this.importFile.filename = null;
                this.importFile.extension = null;
                this.importFile.storage = null;
                this.importFile.rack = null;
                this.importFile.shelve = null;
              }
            })
      }
    }
  },
}
</script>